import * as actionTypes from "../../actions/actionTypes";
import { updateObject } from "../utility";

const initialState = {
  multipleCity: [],
  multipleCenterName: [],
  multipleQualification: [],
  multipleRole: [],
  tableValue: 1,
};

const setTcsMultipleSelect = (state, action) => {
  return updateObject(state, {
    multipleCity: action.multipleCity,
    multipleCenterName: action.multipleCenterName,
    multipleQualification: action.multipleQualification,
    multipleRole: action.multipleRole,
  });
};

const setConfigureTable = (state, action) => {
  return updateObject(state, {
    tableValue: action.tableValue,
  });
};

const tcsJobsDbReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.TCS_MULTIPLE_SELECT:
      return setTcsMultipleSelect(state, action);
    case actionTypes.TCS_CONFIGURE_TABLE:
      return setConfigureTable(state, action);
    default:
      return state;
  }
};
export default tcsJobsDbReducer;
